export type SiteConfig = typeof siteConfig;

const navItems = [
	{
		label: "Application",
		href: "/admin/applications",
	},
	{
		label: "Organisations",
		href: "/admin/organisations",
	},
	{
		label: "Audit Logs",
		href: "/admin/audit-logs",
	},
	{
		label: "Admin Users",
		href: "/admin/users",
	},
	{
		label: "Admin Groups",
		href: "/admin/groups",
	},
	{
		label: "Users",
		href: "/domain/users",
	},
	{
		label: "Groups",
		href: "/domain/groups",
	},
	{
		label: "Profile",
		href: "/domain/profile",
	},
	{
		label: "Domain Audit Logs",
		href: "/domain/audit-logs",
	},
];

export const siteConfig = {
	name: "Account Server",
	description: "Account Server is a simple and secure way to manage your access increff applications.",
	navItems: navItems,
	navMenuItems: [
		...navItems,
		{
			label: "Logout",
			href: "/logout",
		},
	],
};
